import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "/api";

export default function AddCompany() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    company_name: "",
    company_type: "",
    location: "",

    /* 🔥 NEW */
    admin_name: "",
    admin_email: "",
    admin_password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API}/companies`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error saving company");
      }

      alert("Company + Admin created successfully");

      navigate("/dashboard/companies");

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">

      <div>
        <h1 className="text-2xl font-bold text-slate-800">
          Add Company
        </h1>
        <p className="text-sm text-slate-500">
          Create company with admin login
        </p>
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-sm border space-y-6">

        {error && (
          <div className="p-3 text-sm text-red-600 bg-red-50 rounded-lg">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* COMPANY INFO */}
          <Input label="Company Name" name="company_name" value={form.company_name} onChange={handleChange} required />
          <Input label="Company Type" name="company_type" value={form.company_type} onChange={handleChange} />
          <Input label="Location" name="location" value={form.location} onChange={handleChange} />

          {/* 🔥 ADMIN SECTION */}
          <div className="border-t pt-6 mt-6">
            <h2 className="text-lg font-semibold mb-4 text-slate-700">
              Admin Details
            </h2>

            <Input label="Admin Name" name="admin_name" value={form.admin_name} onChange={handleChange} required />
            <Input label="Admin Email" name="admin_email" value={form.admin_email} onChange={handleChange} required />
            <Input label="Admin Password" name="admin_password" type="password" value={form.admin_password} onChange={handleChange} required />
          </div>

          <div className="flex justify-end gap-3 pt-4">

            <button
              type="button"
              onClick={() => navigate("/dashboard/companies")}
              className="px-5 py-2 rounded-lg border text-slate-600 hover:bg-slate-100"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-2 rounded-lg font-semibold ${
                loading
                  ? "bg-slate-400"
                  : "bg-green-600 hover:bg-green-700 text-white"
              }`}
            >
              {loading ? "Saving..." : "Create Company"}
            </button>

          </div>

        </form>
      </div>
    </div>
  );
}

/* INPUT */
const Input = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium mb-2 text-slate-700">
      {label}
    </label>

    <input
      {...props}
      className="w-full border px-4 py-2.5 rounded-xl focus:ring-2 focus:ring-green-500"
    />
  </div>
);